import { Component, Inject, Input, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RejectionDialogueComponent } from '../rejection-dialogue/rejection-dialogue.component';
import { AcceptDialogueComponent } from '../accept-dialogue/accept-dialogue.component';
import { FcPopupComponent } from '../../reach-defaulter/fc-popup/fc-popup.component';
import { FamilyCodeTransmissionService } from '../../services/raintree/Transmission/familyCode-transmission.service';

import { AppConfigService } from '../../services/config/app-config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckDialogComponent } from '../check-dialog/check-dialog.component';
import { ResetDialogComponent } from '../reset-dialog/reset-dialog.component';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { ToastrComponentlessModule, ToastrService } from 'ngx-toastr';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { RitwikTransmissionService } from '../../services/raintree/Transmission/ritwik.transmission.service';
import { debounceTime, filter, switchMap } from 'rxjs';
import { Permissions } from '../../enum/permission';
@Component({
  selector: 'app-manage-dialogue',
  standalone: true,
  imports: [
    MatDialogModule,
    MatIconModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    FormsModule,
    LoaderComponent,
  ],
  templateUrl: './manage-dialogue.component.html',
  styleUrls: ['./manage-dialogue.component.scss', '../../../styles/_dropdown.scss',],
})
export class ManageDialogueComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ManageDialogueComponent>,
    private toaster: ToastrService,
    public dialog: MatDialog,
    private familyCodeTransmissionService: FamilyCodeTransmissionService,
    private _appConfig: AppConfigService,
    private router: Router,
    public route: ActivatedRoute,
    public ritwikTransmissionService: RitwikTransmissionService,
  ) { }
  rowData: any = this.data.data;
  public memKey!: number;
  memstatus: any;
  memberKey: any;
  suggestedRitwikCode: boolean = false
  checkRecordStatus = [5, 6, 2, 7]
  acceptRecordStatus = [5, 6, 2, 7, 10]
  resetRecordStatus = [5, 6, 2, 7, 8, 10, 9, 11]
  rejectRecordStatus = [5, 6, 2, 7, 10, 9]
  fcLoading: boolean = false;
  can_mark_check: boolean = false;
  can_mark_reset: boolean = false;
  can_mark_reject: boolean = false;
  can_mark_approve: boolean = false;
  su_review_data: boolean = false;
  role: any
  reviewDataPemission: any[] = [];
  ritwikNames: any = [];
  filteredRitwikList: any = [];
  finalPerm: any = []
  permissionNames: any = {
  };
  ngOnInit(): void {
    console.log(this.data);
    
    this.callRtService();
    this.permissionNames = this._appConfig.fetchPermissionv3ByViewName();

    (this.rowData.suggestedRitwikName && this.rowData.suggestedRitwikCode) || (!this.rowData.suggestedRitwikName && !this.rowData.suggestedRitwikCode) ? this.suggestedRitwikCode = true : ''
    this.fetchPermissions()
    this.memberKey = this.rowData.memberKey;
    if (this.rowData.memStatus == '2') {
      this.memstatus = 'Active';
    } else if (this.rowData.memStatus == '3') {
      this.memstatus = 'Inactive';
    }
    const philFullName: any =
      (this.rowData.philFirstName !== null
        ? this.rowData.philFirstName
        : 'NA') +
      ' ' +
      (this.rowData.philLastName !== null && this.rowData.philFirstName !== null
        ? this.rowData.philLastName
        : '');
    this.manageruserForm.patchValue({
      fullName: this.rowData.fullName ? this.rowData.fullName : 'NA',
      guardianName: this.rowData.guardianName
        ? this.rowData.guardianName
        : 'NA',
      ritwikName: this.rowData.ritwikName ? this.rowData.ritwikName : 'NA',
      suggestedGuardianName: this.rowData.suggestedGuardianName
        ? this.rowData.suggestedGuardianName
        : 'NA',
      suggestedRitwikName: this.rowData.suggestedRitwikName
        ? this.rowData.suggestedRitwikName
        : 'NA',
      suggestedMemberName: this.rowData.suggestedMemberName
        ? this.rowData.suggestedMemberName
        : 'NA',
      philMemberName: philFullName,
      ritwikCode: this.rowData.suggestedRitwikCode
        ? this.rowData.suggestedRitwikCode
        : 'NA',
      memStatus: this.memstatus ? this.memstatus : 'NA',
      memberFamilyCode: this.rowData.memberFamilyCode
        ? this.rowData.memberFamilyCode
        : 'NA',
      lastIVDate: this.rowData?.istData?.mem_last_transaction_date ?? 'NA',
      email: this.rowData.email ? this.rowData.email : 'NA',
      contactNumber: this.rowData.contactNumber
        ? this.rowData.contactNumber
        : 'NA',
      permanentAddressLine1: this.rowData.permanentAddressLine1
        ? this.rowData.permanentAddressLine1
        : 'NA',
      presentAddressLine1: this.rowData.presentAddressLine1
        ? this.rowData.presentAddressLine1
        : 'NA',
      presentPin: this.rowData.presentPin ? this.rowData.presentPin : 'NA',
      permanentPin: this.rowData.permanentPin
        ? this.rowData.permanentPin
        : 'NA',
      permanentAddressLine2: this.rowData.permanentAddressLine2
        ? this.rowData.permanentAddressLine2
        : 'NA',
      presentAddressLine2: this.rowData.presentAddressLine2
        ? this.rowData.presentAddressLine2
        : 'NA',
      permanentPO: this.rowData.permanentPO ? this.rowData.permanentPO : 'NA',
      presentPO: this.rowData.presentPO ? this.rowData.presentPO : 'NA',
      presentDistrict: this.rowData.presentDistrict
        ? this.rowData.presentDistrict
        : 'NA',
      permanentDistrict: this.rowData.permanentDistrict
        ? this.rowData.permanentDistrict
        : 'NA',
      presentState: this.rowData.presentState
        ? this.rowData.presentState
        : 'NA',
      permanentState: this.rowData.permanentState
        ? this.rowData.permanentState
        : 'NA',
      oldAddress: this.rowData.addressPermanent
        ? this.rowData.addressPermanent
        : 'NA',
      oldState: this.rowData.permanentState
        ? this.rowData.permanentState
        : 'NA',
      oldDistrict: this.rowData.permanentDistrict
        ? this.rowData.permanentDistrict
        : 'NA',
      oldPin: this.rowData.recommendedPinCode
        ? this.rowData.recommendedPinCode
        : 'NA',

      comments: this.rowData.comments ? this.rowData.comments : 'NA',
    });
  }
  manageruserForm = new FormGroup({
    fullName: new FormControl(''),
    guardianName: new FormControl(''),
    ritwikName: new FormControl(''),
    ritwikCode: new FormControl(''),
    suggestedGuardianName: new FormControl(''),
    suggestedMemberName: new FormControl(''),
    suggestedRitwikName: new FormControl(''),
    philMemberName: new FormControl(''),
    memStatus: new FormControl(''),
    memberFamilyCode: new FormControl(''),
    lastIVDate: new FormControl(''),
    email: new FormControl(''),
    contactNumber: new FormControl(''),
    permanentAddressLine1: new FormControl(''),
    presentAddressLine1: new FormControl(''),
    presentAddressLine2: new FormControl(''),
    permanentAddressLine2: new FormControl(''),
    presentPin: new FormControl(''),
    permanentPin: new FormControl(''),
    permanentPO: new FormControl(''),
    presentPO: new FormControl(''),
    presentDistrict: new FormControl(''),
    permanentDistrict: new FormControl(''),
    presentState: new FormControl(''),
    permanentState: new FormControl(''),
    comments: new FormControl(''),
    oldAddress: new FormControl(''),
    oldState: new FormControl(''),
    oldDistrict: new FormControl(''),
    oldPin: new FormControl('')
  });
  rejectionDatum() {
    const dialogRef = this.dialog.open(RejectionDialogueComponent, {
      data: this.rowData.memberKey,
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value) this.dialogRef.close(true);
    });

  }
  reqBody: any = {}
  fetchPermissions() {
    this.finalPerm = [];
    const countryPerm = this.permissionNames['INDIA'];
    if (this.data?.state != '') {
      this.finalPerm = countryPerm?.allStatesPerm;
      const statePerm = countryPerm.statePerms[this.data?.state];
      if (this.data?.district != '' && statePerm) {
        this.finalPerm = [...this.finalPerm, ...statePerm?.allDistrictsPerm, ...statePerm?.districtPerms[this.data?.district]];
      }
    }
    this.su_review_data = this.finalPerm.indexOf(Permissions.SuReview) !== -1 ? true : false;
    this.can_mark_approve = this.finalPerm.indexOf(Permissions.ApproveUpdatedData) !== -1 ? true : false;
    this.can_mark_check = this.finalPerm.indexOf(Permissions.SUUpdatedData) !== -1 ? true : false;
    this.can_mark_reject = this.finalPerm.indexOf(Permissions.RejectUpdatedData) !== -1 ? true : false;
    this.can_mark_reset = this.finalPerm.indexOf(Permissions.ResetUpdatedData) !== -1 ? true : false;
  }
  fetchPaylod() {
    return {
      suggestedMemberName: this.manageruserForm.get('suggestedMemberName')?.value,
      suggestedGuardianName: this.manageruserForm.get('suggestedGuardianName')?.value,
      suggestedRitwikName: this.manageruserForm.get('suggestedRitwikName')?.value,
      contactNumber: this.manageruserForm.get('contactNumber')?.value,
      email: this.manageruserForm.get('email')?.value,
      permanentAddressLine1: this.manageruserForm.get('permanentAddressLine1')?.value,
      permanentPin: this.manageruserForm.get('permanentPin')?.value,
      permanentPO: this.manageruserForm.get('permanentPO')?.value,
      permanentState: this.manageruserForm.get('permanentState')?.value,
      permanentDistrict: this.manageruserForm.get('permanentDistrict')?.value,
      presentAddressLine1: this.manageruserForm.get('presentAddressLine1')?.value,
      presentPin: this.manageruserForm.get('presentPin')?.value,
      presentPO: this.manageruserForm.get('presentPO')?.value,
      presentState: this.manageruserForm.get('presentState')?.value,
      presentDistrict: this.manageruserForm.get('presentDistrict')?.value,
      memStatus: this.rowData.memStatus,
      comments: this.manageruserForm.get('comments')?.value,
      permanentLandmark: this.manageruserForm.get('permanentLandmark')?.value,
      presentLandmark: this.manageruserForm.get('presentLandmark')?.value,
      inactiveReason: this.rowData?.inactiveReason,
      suggestedRitwikCode: this.suggestedRitwikCode ? this.ritwikNames[0]?.dwd_ritwik_code : ''
    }
  }
  acceptDialogue() {
    if (this.suggestedRitwikCode || (this.rowData.suggestedRitwikName && !this.rowData.suggestedRitwikCode && this.manageruserForm.get('ritwikCode')?.value?.length === 12)) {
      const dialogRef = this.dialog.open(AcceptDialogueComponent, {
        data: {
          data: this.rowData.memberKey, reqBody: this.can_mark_approve ? this.fetchPaylod() : '', review: this.su_review_data
        }
      });
      dialogRef.afterClosed().subscribe((value) => {
        if (value) this.dialogRef.close(true);
      });
    } else
      this.toaster.error('Check ritwik name and ritwik code (12 digit) again.')
  }
  checkDatum() {
    if (this.suggestedRitwikCode || (this.rowData.suggestedRitwikName && !this.rowData.suggestedRitwikCode && this.manageruserForm.get('ritwikCode')?.value?.length === 12)) {
      const dialogRef = this.dialog.open(CheckDialogComponent, {
        data: {
          data: this.rowData.memberKey, reqBody: this.can_mark_check ? this.fetchPaylod() : '', review: this.su_review_data
        }
      });
      dialogRef.afterClosed().subscribe((value) => {
        if (value) this.dialogRef.close(true);
      });
    } else
      this.toaster.error('Check ritwik name and ritwik code (12 digit again.')
  }
  resetDatum() {
    const dialogRef = this.dialog.open(ResetDialogComponent, {
      data: this.rowData.memberKey,
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value) this.dialogRef.close(true);
    });

  }
  fcDetails: any[] = [];
  onFcClick() {
    if (this.rowData.memberFamilyCode != null) {
      this.fcLoading = true;
      this.familyCodeTransmissionService
        .getFamilyDetails(this.rowData.memberFamilyCode)
        .subscribe({
          next: (response: any) => {
            if (!response.error && response.data.length > 0) {
              this.fcDetails = response.data;
            }
            this.fcLoading = false;
            const data = response.data.map(
              (item: {
                mem_name: string;
                mem_surname: string;
                mem_last_transaction_date: any;
              }) => ({
                ...item,
                name: item.mem_name + ' ' + item.mem_surname,
                lid: item.mem_last_transaction_date,
              })
            );
            this.dialog.open(FcPopupComponent, {
              data: {
                fcData: data,
                fc: this.rowData.memberFamilyCode,
              },
            });
          },
          error: (error) => {
            this.fcLoading = false;
            this.toaster.error(error);
          },
        });
    }
  }
  callRtService() {

    this.manageruserForm
      .get('ritwikCode')?.valueChanges.subscribe((value: any) => {
        if (value?.length === 3)
          this.searchRitwikName(value)
        else if (value?.length === 0) {
          this.ritwikNames = this.filteredRitwikList = []
          this.manageruserForm.controls['suggestedRitwikName'].setValue(this.rowData.suggestedRitwikName);
          this.suggestedRitwikCode = false
        }
        else
          this.filteredRitwikList = this.filterList(value)
      })
  }
  filterList(value: any) {
    return this.ritwikNames.filter((item: any) =>
      item.dwd_worker_name.includes(value.toUpperCase())
    )
  }
  searchRitwikName(rtname: any) {
    this.ritwikTransmissionService.getRitwikListV2(rtname).subscribe({
      next: (response: any) => {
        if (!response.error) {
          this.ritwikNames = response.data
        }
      },
      error: (error) => {
        this.toaster.error(error)
      },
    });
  }
  automatedDropVal(event: any) {
    this.manageruserForm.controls['suggestedRitwikName'].setValue(event.dwd_worker_name);
    this.manageruserForm.controls['ritwikCode'].setValue(event.dwd_ritwik_code);
    this.suggestedRitwikCode = true

  }
}
